module.exports = __webpack_public_path__ + "img/noGroups.449fbad4.svg";